export default __webpack_public_path__ + "resources/icons/n110-65c1.png";